// import React, { useEffect, useState } from 'react';
// import { TextField } from '@mui/material';

// const QtyInputNested = ({
//   midIndex,
//   i,
//   index,
//   value,
//   name,
//   theme,
//   disabled,
//   error,
//   helperText,
//   setValues,
//   handleBlur,
//   isSubmitting
// }) => {
//   const [localQty, setLocalQty] = useState(value || '');

//   useEffect(() => {
//     if (value !== undefined) {
//       setLocalQty(value);
//     }
//   }, [value]);

//   useEffect(() => {
//     if (isSubmitting) {
//       updateDispatchQty(localQty);
//     }
//   }, [isSubmitting]);

//   const handleChange = (e) => {
//     setLocalQty(e.target.value);
//   };

//   const handleBlurInternal = (e) => {
//     updateDispatchQty(localQty);
//     handleBlur(e);
//   };

//   const updateDispatchQty = (updatedQty) => {
//     setValues(prevValues => {
//       const updatedValues = [...prevValues];
//       updatedValues[midIndex] = {
//         ...updatedValues[midIndex],
//         ProcessData: updatedValues[midIndex].ProcessData.map((process, processIndex) => {
//           if (processIndex === i) {
//             return {
//               ...process,
//               DispatchDetails: process.DispatchDetails.map((detail, detailIndex) => {
//                 if (detailIndex === index) {
//                   return {
//                     ...detail,
//                     DispatchQty: updatedQty
//                   };
//                 }
//                 return detail;
//               })
//             };
//           }
//           return process;
//         })
//       };
//       return updatedValues;
//     });
//   };
//   console.log(`QtyInputNested (${midIndex}, ${i}, ${index}):`, value, localQty);

//   return (
//     <TextField
//       disabled={disabled}
//       margin="dense"
//       variant="filled"
//       fullWidth
//       value={localQty}
//       name={name}
//       onChange={handleChange}
//       onBlur={handleBlurInternal}
//       error={error}
//       helperText={helperText}
//       InputLabelProps={{
//         shrink: true,
//         style: {
//           color: theme.palette.text.primary,
//         },
//       }}
//       sx={{
//         width: {
//           xs: '100px',
//           sm: '100px',
//           md: '100px',
//         },
//         height: '40px',
//         '& .MuiInputBase-root': {
//           fontSize: '0.8rem',
//           height: '40px',
//         },
//         '& .MuiInputBase-input': {
//           padding: '0 12px',
//           height: '40px',
//           lineHeight: '40px',
//         },
//       }}
//     />
//   );
// };

// export default React.memo(QtyInputNested);

import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

// Assume this component is rendered inside a loop or mapping where you get `detail`, `i`, `index`, etc.
// For example, if you're mapping over `ProcessData` and `DispatchDetails`
const QtyInputNested = ({
    midIndex,
    i,
    index,
    detail, // The 'detail' object containing DispatchQty
    d,
    theme,
    values, // The overall form values (passed down from parent)
    setValues, // The setter function for overall form values (from useState in parent)
    handleBlur, // Formik's handleBlur or a custom one for touched state
    touched, // Formik's touched object
    errors, // Formik's errors object
}) => {
    // 1. Introduce local state for this specific input's value
    const [localQty, setLocalQty] = useState(detail.DispatchQty || '');

    // 2. Sync local state with prop changes (e.g., when initialValues change or on form reset)
    useEffect(() => {
        setLocalQty(detail.DispatchQty || '');
    }, [detail.DispatchQty]); // Only re-run if detail.DispatchQty changes

    // 3. Handle change locally without updating the parent state immediately
    const handleChange = (e) => {
        setLocalQty(e.target.value);
        // ⭐ IMPORTANT: Do NOT call setValues here. This prevents the parent re-render.
    };

    // 4. Update the parent state only when the input loses focus
    const handleBlurInternal = (e) => {
        // Your existing deep update logic, but using `localQty`
        if (values?.[midIndex]?.ProcessData?.[i]?.DispatchDetails?.[index]) {
            setValues(prevValues => {
                const updatedValues = [...prevValues];
                updatedValues[midIndex] = {
                    ...updatedValues[midIndex],
                    ProcessData: updatedValues[midIndex].ProcessData.map((process, processIndex) => {
                        if (processIndex === i) {
                            return {
                                ...process,
                                DispatchDetails: process.DispatchDetails.map((det, detIndex) => {
                                    if (detIndex === index) {
                                        return {
                                            ...det,
                                            DispatchQty: localQty // Use the local state value here
                                        };
                                    }
                                    return det;
                                })
                            };
                        }
                        return process;
                    })
                };
                return updatedValues;
            });
        }
        // Call the original handleBlur (if it's from Formik) to mark the field as touched
        handleBlur(e);
    };

    // Construct the name for error/touched access dynamically
    const fieldName = `ProcessData[${i}].DispatchDetails[${index}].DispatchQty`;
    const formikErrorPath = touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty &&
                            Boolean(errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty);
    const formikHelperTextPath = touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty &&
                                 errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty;

    return (
        <TextField
            disabled={d}
            margin="dense"
            variant="filled"
            fullWidth
            value={localQty} // Controlled by local state
            name={`values[${midIndex}].${fieldName}`} // This name is for the DOM element, adjust if needed by your schema
            InputLabelProps={{
                shrink: true,
                style: {
                    color: theme.palette.text.primary
                }
            }}
            sx={{
                width: {
                    xs: "100px",
                    sm: "100px",
                    md: "100px",
                },
                height: '40px',
                "& .MuiInputBase-root": {
                    fontSize: "0.8rem",
                    height: "40px",
                },
                "& .MuiInputBase-input": {
                    padding: "0 12px",
                    height: "40px",
                    lineHeight: "40px",
                },
            }}
            onChange={handleChange} // Use the local change handler
            onBlur={handleBlurInternal} // Use the local blur handler to sync with parent
            error={formikErrorPath}
            helperText={formikHelperTextPath}
        />
    );
};

export default React.memo(QtyInputNested); // Memoize if this component re-renders frequently
